import * as React from 'react';
import { Component } from 'react';
import { parse } from 'query-string';
import BPromise from 'bluebird';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { Loader } from 'Src/components/Loader/Loader';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import { AppUser } from 'Src/views/App/App';
import './TournamentTags.css';
import { History, Location } from 'history';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { getTournamentTagColor } from 'Src/helpers/cell/cell';
import { TournamentTag } from 'Src/models/tournamentTag';
import {
  createTournamentTag,
  deleteTournamentTag,
  getAllTournamentTags,
  getTournamentTags,
  getTournamentTagsCount,
  updateTournamentTag
} from 'Src/helpers/service/adminSU/tournamentTags';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlus, faTags, faTrash } from '@fortawesome/free-solid-svg-icons';
import { USER_TAG_DEFAULT_COLOR, USER_TAG_PALETTE } from 'Src/helpers/tags/tagColors';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'tagName',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['tagName']
  },
  {
    text: 'Description',
    field: 'tagDdescription',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['tagDescription']
  },
  /* {
    text: 'Colour',
    field: 'tagColor',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getTournamentTagColor
  },*/
  {
    text: 'Colour',
    field: 'tagColor',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: row => <td className="color-thumbnail-cell">{getTournamentTagColor(row)}</td>
  },
  {
    text: 'Public',
    field: 'isPublic',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: ({ isPublic }) => {
      const displayValue = isPublic ? 'Yes' : 'No';
      return <td>{displayValue}</td>;
    }
  }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: TournamentTag[];
  currentPage: number;
  selectedItems: TournamentTag[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;

  isCreating: boolean;
  editingId: string;
  draftName: string;
  draftDescription: string;
  draftColor: string;
  draftIsPublic: boolean;
  error: string;
  isDeleteTournamentTagModalOpen: boolean;
}

export class TournamentTags extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',

      isCreating: false,
      editingId: '',
      draftName: '',
      draftDescription: '',
      draftColor: USER_TAG_DEFAULT_COLOR,
      draftIsPublic: false,
      error: '',
      isDeleteTournamentTagModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getTournamentTagsPromise = getTournamentTags(user, serverQueryFilter);
    const getTournamentTagsCountPromise = getTournamentTagsCount(user, where);

    return BPromise.all([getTournamentTagsCountPromise, getTournamentTagsPromise]).then(
      ([countObj, tournamentTags]) => {
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: isShowFilter,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: tournamentTags,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false
        });

        return true;
      }
    );
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedTournamentTag = items[index];

    const selectedTournamentTagIndex = selectedItems.findIndex(
      tournamentTag => selectedTournamentTag.id === tournamentTag.id
    );
    let selectedTournamentTagUpdated = [...selectedItems];

    if (selectedTournamentTagIndex !== -1) {
      selectedTournamentTagUpdated.splice(selectedTournamentTagIndex, 1);
    } else {
      selectedTournamentTagUpdated.push(selectedTournamentTag);
    }

    this.setState({
      selectedItems: selectedTournamentTagUpdated
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const tournamentTagsFiltered = items.filter(tournamentTag => {
      return selectedItems.every(selectedTournamentTag => selectedTournamentTag.id !== tournamentTag.id);
    });

    const selectedTournamentTag = [...selectedItems, ...tournamentTagsFiltered];

    this.setState({
      selectedItems: selectedTournamentTag,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllTournamentTags(user, where).then(tournamentTags => {
      const tournamentTagsFiltered = tournamentTags.filter(tournamentTag => {
        return selectedItems.every(selectedTournamentTag => selectedTournamentTag.id !== tournamentTag.id);
      });

      const selectedTournamentTags = [...selectedItems, ...tournamentTagsFiltered];

      this.setState({
        selectedItems: selectedTournamentTags,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      total: index
    });
  };

  normalizeName = (name: string): string =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .slice(0, 40);

  isNameTaken = (name: string, exceptId = ''): boolean => {
    const normalized = this.normalizeName(name).toLowerCase();
    return this.state.items.some(tag => tag.id !== exceptId && tag.tagName.toLowerCase() === normalized);
  };

  resetDraft = (): void => {
    this.setState({
      isCreating: false,
      editingId: '',
      draftName: '',
      draftDescription: '',
      draftColor: USER_TAG_DEFAULT_COLOR,
      draftIsPublic: false,
      error: ''
    });
  };

  onCreateTournamentTagClick = (): void => {
    this.setState({
      isCreating: true,
      editingId: '',
      selectedItems: [],
      draftName: '',
      draftDescription: '',
      draftColor: USER_TAG_DEFAULT_COLOR,
      draftIsPublic: false,
      error: ''
    });
  };

  startEdit = (tag: TournamentTag): void => {
    this.setState({
      isCreating: false,
      editingId: tag.id,
      selectedItems: [],
      draftName: tag.tagName,
      draftDescription: tag.tagDescription || '',
      draftColor: tag.tagColor || USER_TAG_DEFAULT_COLOR,
      draftIsPublic: Boolean(tag.isPublic),
      error: ''
    });
  };

  saveDraft = (): void => {
    const { isCreating, editingId, draftName, draftDescription, draftColor, draftIsPublic } = this.state;
    const tagName = this.normalizeName(draftName);
    if (!tagName || this.isNameTaken(tagName, editingId)) return;

    const data = {
      tagName,
      tagDescription: String(draftDescription || '').trim(),
      tagColor: draftColor,
      isPublic: draftIsPublic,
      schoolId: this.props.user.activeSchoolId
    };

    this.setState({ isLoading: true, error: '' });
    const request = isCreating
      ? createTournamentTag(this.props.user, data)
      : updateTournamentTag(this.props.user, data, editingId);

    request
      .then(() => {
        this.resetDraft();
        this.setItems();
      })
      .catch(error => {
        console.error(error);
        this.setState({ isLoading: false, error: `Unable to ${isCreating ? 'create' : 'update'} tournament tag.` });
      });
  };

  renderSwatches = (): React.ReactNode => (
    <div className="tournamentTags__swatches">
      {USER_TAG_PALETTE.map(color => (
        <button
          key={color}
          type="button"
          className={`tournamentTags__swatch ${this.state.draftColor === color ? 'isActive' : ''}`}
          style={{ backgroundColor: color }}
          aria-label={`Choose ${color}`}
          onClick={() => this.setState({ draftColor: color })}
        />
      ))}
    </div>
  );

  renderTournamentTagEditorModal = (): React.ReactNode => {
    const { editingId, draftName, draftDescription, draftColor, draftIsPublic } = this.state;
    const isOpen = this.state.isCreating || Boolean(editingId);
    const normalizedName = this.normalizeName(draftName);
    const duplicate = Boolean(normalizedName && this.isNameTaken(normalizedName, editingId));

    return (
      <SimpleModal
        isOpen={isOpen}
        title={this.state.isCreating ? 'Create tournament tag' : 'Edit tournament tag'}
        onCloseClick={this.resetDraft}
        onBackdropClick={this.resetDraft}
        showFooter={false}
        isBodyBold={false}
        customClass="tournamentTagEditorModal"
        dialogStyle={{ maxWidth: 680 }}
      >
        <div className="tournamentTagEditor">
          <div className="tournamentTagEditor__intro">
            {this.state.isCreating
              ? 'Create a reusable tag for organising tournaments.'
              : 'Update the tag details. Changes apply everywhere this tag is used.'}
          </div>

          <label className="tournamentTagEditor__field">
            <span>Tag name</span>
            <input
              autoFocus
              value={draftName}
              maxLength={40}
              placeholder="e.g. Regional championship"
              onChange={event => this.setState({ draftName: event.target.value })}
              onKeyDown={event => event.key === 'Enter' && this.saveDraft()}
            />
            {duplicate ? <em>That tag already exists.</em> : null}
          </label>

          <label className="tournamentTagEditor__field">
            <span>Description</span>
            <textarea
              value={draftDescription}
              maxLength={240}
              placeholder="Add a short description"
              onChange={event => this.setState({ draftDescription: event.target.value })}
            />
          </label>

          <div className="tournamentTagEditor__field">
            <span>Colour</span>
            {this.renderSwatches()}
          </div>

          <div className="tournamentTagEditor__options">
            <div>
              <span className="tournamentTagEditor__label">Preview</span>
              <span className="tournamentTags__badge" style={{ color: draftColor, backgroundColor: `${draftColor}1A` }}>
                <i style={{ backgroundColor: draftColor }} />
                {normalizedName || 'Tag name'}
              </span>
            </div>
            <label className="tournamentTags__publicToggle">
              <input
                type="checkbox"
                checked={draftIsPublic}
                onChange={event => this.setState({ draftIsPublic: event.target.checked })}
              />
              <span>
                <strong>{draftIsPublic ? 'Public' : 'Private'}</strong>
                Public tags may be shown outside the admin console.
              </span>
            </label>
          </div>

          <div className="tournamentTagEditor__actions">
            <button type="button" className="sit-btn sit-btn--ghost" onClick={this.resetDraft}>
              Cancel
            </button>
            <button
              type="button"
              className="sit-btn sit-btn--primary"
              disabled={!normalizedName || duplicate}
              onClick={this.saveDraft}
            >
              {this.state.isCreating ? 'Create tag' : 'Save changes'}
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  };

  deleteTournamentTagModalOpen = (): void => {
    this.setState({
      isDeleteTournamentTagModalOpen: true
    });
  };

  deleteTournamentTagModalClose = (): void => {
    this.setState({
      isDeleteTournamentTagModalOpen: false
    });
  };

  onDeleteTournamentTagClick = () => {
    const { selectedItems } = this.state;

    this.setState({ isLoading: true });
    const promises = selectedItems.map(tournamentTag => {
      return deleteTournamentTag(this.props.user, tournamentTag.id);
    });
    BPromise.all(promises).then(() => {
      this.setState({
        selectedItems: [],
        isDeleteTournamentTagModalOpen: false
      });
      this.setItems();
    });
  };

  renderDeleteTournamentTagModal() {
    const { selectedItems, isDeleteTournamentTagModalOpen } = this.state;
    const isSingleTag = selectedItems.length === 1;

    return (
      <SimpleModal
        isOpen={isDeleteTournamentTagModalOpen}
        title={isSingleTag ? 'Delete tournament tag?' : `Delete ${selectedItems.length} tournament tags?`}
        body={
          <div className="tournamentTagsDelete">
            <div className="tournamentTagsDelete__icon" aria-hidden="true">
              <FontAwesomeIcon icon={faTrash} />
            </div>
            <div>
              <p>{isSingleTag ? 'This tag will be permanently removed.' : 'These tags will be permanently removed.'}</p>
              <div className="tournamentTagsDelete__tags">
                {selectedItems.map(tag => (
                  <span
                    key={tag.id}
                    className="tournamentTags__badge"
                    style={{ color: tag.tagColor, backgroundColor: `${tag.tagColor}1A` }}
                  >
                    <i style={{ backgroundColor: tag.tagColor }} />
                    {tag.tagName}
                  </span>
                ))}
              </div>
              <p className="tournamentTagsDelete__note">
                The {isSingleTag ? 'tag' : 'tags'} will also be removed from every tournament where{' '}
                {isSingleTag ? 'it is' : 'they are'} currently applied. This action cannot be undone.
              </p>
            </div>
          </div>
        }
        buttonText={isSingleTag ? 'Delete tag' : 'Delete tags'}
        onButtonClick={this.onDeleteTournamentTagClick}
        onCloseClick={this.deleteTournamentTagModalClose}
        buttonCancelText="Cancel"
        isBodyBold={false}
        customClass="tournamentTagsDeleteModal"
        dialogStyle={{ maxWidth: 520 }}
      />
    );
  }

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      total,
      isCreating,
      editingId,
      error
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const selectedIds = new Set(selectedItems.map(item => item.id));
    const isPageSelected = items.length > 0 && items.every(item => selectedIds.has(item.id));
    const query = filters.tagName || '';
    const sortIndicator = sortColumnsName === 'tagName' ? (sortDirection === 'ASC' ? '↑' : '↓') : '↕';

    return (
      <div className="tournamentTagsPage">
        {this.renderDeleteTournamentTagModal()}
        {this.renderTournamentTagEditorModal()}
        <header className="tournamentTags__pageHeader">
          <div className="tournamentTags__heading">
            <div className="tournamentTags__titleRow">
              <h1>Tournament tags</h1>
              <span className="tournamentTags__count">{total}</span>
            </div>
            <p>
              Use tags to organise tournaments and make them easier to find. Public tags can also be shown outside the
              admin console.
            </p>
          </div>
          <button
            type="button"
            className="sit-btn sit-btn--primary tournamentTags__create"
            onClick={this.onCreateTournamentTagClick}
            disabled={isCreating}
          >
            <FontAwesomeIcon icon={faPlus} /> Create tag
          </button>
        </header>

        <main className="tournamentTags__mainCard">
          <div className="tournamentTags__toolbar">
            <div className="tournamentTags__searchWrap">
              <input
                className="tournamentTags__search"
                value={query}
                placeholder="Search tags..."
                aria-label="Search tournament tags"
                onChange={event => this.onTableFilterChange(event, 'tagName')}
                onKeyDown={event => event.key === 'Enter' && this.onApplyFilterClick()}
              />
              {query ? (
                <button type="button" onClick={this.onClearFilterClick} aria-label="Clear tag search">
                  ×
                </button>
              ) : null}
            </div>
          </div>

          {error ? <div className="tournamentTags__error">{error}</div> : null}

        {selectedItems.length > 0 && (
          <div className="tournamentTags__selection">
            <span>
              {selectedItems.length} {selectedItems.length === 1 ? 'tag' : 'tags'} selected
            </span>
            <div>
              {selectedItems.length === 1 && (
                <button
                  type="button"
                  className="sit-btn sit-btn--secondary"
                  onClick={() => this.startEdit(selectedItems[0])}
                >
                  <FontAwesomeIcon icon={faPen} /> Edit tag
                </button>
              )}
              <button type="button" className="sit-btn sit-btn--danger" onClick={this.deleteTournamentTagModalOpen}>
                <FontAwesomeIcon icon={faTrash} /> Delete {selectedItems.length === 1 ? 'tag' : 'tags'}
              </button>
              <button type="button" className="sit-btn sit-btn--ghost" onClick={this.onUnselectAllClick}>
                Clear selection
              </button>
            </div>
          </div>
        )}

        <div className="tournamentTags__card">
          <table className="tournamentTags__table">
            <thead>
              <tr>
                <th className="tournamentTags__check">
                  <SelectAllCheckbox
                    compact
                    isChecked={isPageSelected || isSelectAllChecked}
                    totalCount={total}
                    currentPage={currentPage}
                    pageItemsCount={items.length}
                    selectedItems={selectedItems}
                    onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                    onSelectAllClick={this.onSelectAllClick}
                    onUnselectAllClick={this.onUnselectAllClick}
                  />
                </th>
                <th>
                  <button type="button" onClick={() => this.onTableSortClick('tagName')}>
                    Tag <span>{sortIndicator}</span>
                  </button>
                </th>
                <th>Description</th>
                <th>Visibility</th>
              </tr>
            </thead>
            <tbody>
              {items.map((tag, index) => (
                <tr
                  key={tag.id}
                  className={selectedIds.has(tag.id) ? 'isSelected' : ''}
                  onClick={() => this.startEdit(tag)}
                >
                  <td className="tournamentTags__check" onClick={event => event.stopPropagation()}>
                    <input type="checkbox" checked={selectedIds.has(tag.id)} onChange={() => this.onItemClick(index)} />
                  </td>
                  <td>
                    <span
                      className="tournamentTags__badge"
                      style={{ color: tag.tagColor, backgroundColor: `${tag.tagColor}1A` }}
                    >
                      <i style={{ backgroundColor: tag.tagColor }} />
                      {tag.tagName}
                    </span>
                  </td>
                  <td className="tournamentTags__description">{tag.tagDescription || '—'}</td>
                  <td>
                    <span
                      className={tag.isPublic ? 'tournamentTags__visibility isPublic' : 'tournamentTags__visibility'}
                    >
                      {tag.isPublic ? 'Public' : 'Private'}
                    </span>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr>
                  <td colSpan={4} className="tournamentTags__empty">
                    <ListEmptyState
                      icon={faTags}
                      title={query ? 'No tournament tags match your search' : 'No tournament tags yet'}
                      description={
                        query
                          ? 'Try changing or clearing the search to see more tournament tags.'
                          : 'Create a tag to organise tournaments and make them easier to find.'
                      }
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {total > 0 && (
          <div className="tournamentTags__pagination">
            <Pagination2
              currentPage={currentPage}
              setCurrentPageParams={this.setCurrentPageParams}
              total={total}
              modern={true}
            />
          </div>
        )}
        </main>
      </div>
    );
  }
}
